import type { JwtTokens } from '@wizbii-utils/angular/jwt';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class JwtRefreshStateService {
  isRefreshing = false;
  readonly tokenSubject = new BehaviorSubject<JwtTokens | null>(null);
}
